import { render, staticRenderFns } from "./ShipTab.vue?vue&type=template&id=7aafac12&scoped=true&"
import script from "./ShipTab.vue?vue&type=script&lang=js&"
export * from "./ShipTab.vue?vue&type=script&lang=js&"
import style0 from "./ShipTab.vue?vue&type=style&index=0&id=7aafac12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aafac12",
  null
  
)

export default component.exports